<template>
  <transition name="plus-icon">
    <div class="modelBox" v-if="recruit.modelShow">
      <div class="model">
        <div class="head">
          <p class="title">{{ info.title }}</p>
          <p class="tip">{{ info.tip }}</p>
        </div>
        <div class="content">
          <div class="part">
            <h3>职责描述：</h3>
            <p v-for="(item, index) in info.duty" :key="index">
              {{ index + 1 }}、{{ item }}
            </p>
          </div>
          <div class="part">
            <h3>任职要求：</h3>
            <p v-for="(item, index) in info.requirement" :key="index">
              {{ index + 1 }}、{{ item }}
            </p>
          </div>
          <div class="part" v-if="info.about">
            <h3>实习相关</h3>
            <p v-for="(item, index) in info.about" :key="index">
              {{ index + 1 }}、 {{ item }}
            </p>
          </div>
          <div class="part" v-if="info.tel">
            <h3>简历投递</h3>
            <p>{{ info.tel }}</p>
          </div>
        </div>
        <div class="btn hvr-shutter-out-horizontal" @click="closeModal">
          <p>关闭</p>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters({ recruit: "recruit", info: "recruitInfo" }),
  },
  methods: {
    ...mapMutations(["changeRModel"]),
    closeModal() {
      this.changeRModel(false);
    },
  },
};
</script>

<style lang="less" scoped>
.plus-icon-enter-active {
  transition: opacity 0.5s;
}
.plus-icon-enter {
  opacity: 0;
}
.plus-icon-leave-active {
  transition: opacity 0.5s;
}
.plus-icon-leave-to {
  opacity: 0;
}
.plus-icon-enter-to {
  opacity: 1;
}
.hvr-shutter-out-horizontal:before {
  background: rgba(255, 125, 51, 1);
}

.modelBox {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 100;
  background: rgba(0, 0, 0, 0.6);
  .model {
    position: fixed;
    width: 400px;
    height: 500px;
    background: rgba(255, 255, 255, 1);
    background-image: url("../assets/brid.png");
    background-position: 0% 100%;
    background-size: 200px 130px;
    background-repeat: no-repeat;
    border-radius: 15px;
    top: 50%;
    left: 50%;
    margin-left: -172.5px;
    margin-top: -220px;
    .head {
      width: 250px;
      height: 60px;
      // background: url("../assets/button.png");
      border-radius: 30px;
      background: rgba(255, 125, 51, 1);

      background-size: 100% 100%;
      position: absolute;
      top: -32px;
      left: 50%;
      margin-left: -125px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .title{
        font-weight: bold;
      }
      p {
        font-size: 18px;
        color: rgba(255, 255, 255, 1);
      }
      .tip {
        font-size: 14px;
        color: rgba(255, 255, 255, 0.8);
      }
    }
    .content {
      width: 360px;
      margin: 20px auto 0;
      height: 420px;
      overflow: auto;
      h3 {
        margin-top: 16px;
        margin-bottom: 4px;
        text-align: justify;
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #333333;
      }
      p {
        font-size: 13px;
        color: rgba(51, 51, 51, 1);
        margin: 0 !important;
        padding: 0 !important;
      }
    }
    .btn {
      width: 220px;
      overflow: hidden;
      height: 48px;
      background: rgba(255, 125, 51, 0.7);
      border-radius: 27px;
      cursor: pointer;
      transform: scale(0.7);
      position: absolute;
      bottom: 10px;
      left: 50%;
      margin-left: -110px;
      p {
        font-size: 26px;
        color: rgba(255, 255, 255, 1);
        text-align: center;
        line-height: 48px;
      }
    }
  }
}
//滚动条样式
::-webkit-scrollbar {
  width: 10px;
}
/* 垂直滚动条的滑动块 */
::-webkit-scrollbar-thumb:vertical {
  border-radius: 4px;
  -webkit-box-shadow: inset 0 0 6px rgba(255, 125, 51, 0.5);
  background-color: rgba(255, 125, 51, 0.5);
}

::-webkit-scrollbar-track {
  box-shadow: 0px 0px 3px #dfdfdf inset;
  border-radius: 10px;
  background: #eee;
}
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(255, 125, 51, 0.7);
}
</style>



// WEBPACK FOOTER //
// src/components/recruitModal.vue